/**
 * Setup map pins
 */

export const addPins = ({ google, map, mapData, infowindow, bounds }) => {
	const markers = [];
	mapData.pins.forEach((marker) => {
		// get the pin's details
		const { title, content } = marker;
		// default to using title as info window's content
		let info = title;
		// but if we have content
		if (content) {
			// parse the info window content to prevent xss
			const doc = new DOMParser().parseFromString(content, 'text/html');
			// use the info window content
			info = doc.documentElement.textContent;
		}
		// create the pin
		const latLng = new google.maps.LatLng(marker.lat, marker.lng);
		const pin = new google.maps.Marker({
			map,
			position: latLng,
			title,
			optimized: false,
			zIndex: 1,
			icon: {
				url: `${mapData.url}/dist/assets/images/pins/pin-generic.svg`,
				scaledSize: new google.maps.Size(50, 50),
			},
		});
		const logo = new google.maps.Marker({
			map,
			position: latLng,
			title,
			optimized: false,
			zIndex: 1,
			icon: {
				url: marker?.img,
				anchor: new google.maps.Point(15, 47),
				scaledSize: new google.maps.Size(30, 30),
			},
		});
		// add this marker for looping over later
		markers.push({ pin, logo });
		// activate the info window when clicking this pin
		const moveToMarker = (withZoom = false) => {
			// move to this marker
			map.panTo(pin.position);
			// open the info window with this pin's content
			infowindow.setContent(info);
			infowindow.open({
				anchor: pin,
				map,
			});
			// move all markers to back and this one to front
			markers.forEach((mark) => {
				mark.pin.setZIndex(1);
				mark.logo.setZIndex(1);
			});
			pin.setZIndex(2);
			logo.setZIndex(2);
			// maybe zoom to this pin
			if (withZoom) {
				map.setZoom(9);
			}
		};
		pin.addListener('click', () => moveToMarker());
		logo.addListener('click', () => moveToMarker());
		// add to bounds (so know where to center on screen)
		bounds.extend(latLng);
		// activate this pin on click of corresponding sidebar button
		document
			.querySelector(`[data-button-id="${marker.id}-button"`)
			?.addEventListener('click', () => moveToMarker(true));
	});

	// handle map zooming
	google.maps.event.addListener(map, 'zoom_changed', () => {
		const zoom = map.getZoom();
		let sizes = {
			pin: {
				scaledSize: [50, 50],
			},
			logo: {
				anchor: [14, 47],
				scaledSize: [28, 28],
			},
		};
		if (zoom >= 8) {
			sizes = {
				pin: {
					scaledSize: [75, 75],
				},
				logo: {
					anchor: [22, 68.5],
					scaledSize: [42, 42],
				},
			};
		}
		// resize pins if they're not the correct size already
		if (markers[0].pin.icon.scaledSize.width !== sizes.pin.scaledSize[0]) {
			markers.forEach((marker) => {
				marker.pin.setIcon({
					url: marker.pin.icon.url,
					scaledSize: new google.maps.Size(
						sizes.pin.scaledSize[0],
						sizes.pin.scaledSize[1]
					),
				});
				marker.logo.setIcon({
					url: marker.logo.icon.url,
					scaledSize: new google.maps.Size(
						sizes.logo.scaledSize[0],
						sizes.logo.scaledSize[1]
					),
					anchor: new google.maps.Point(
						sizes.logo.anchor[0],
						sizes.logo.anchor[1]
					),
				});
			});
		}
	});

	// send the markers
	return markers;
};
